import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  // 기본 컨테이너
  container: {
    backgroundColor: '#f0f2f5',
  },
  
  // 에러 배너
  errorBanner: {
    position: 'fixed' as any,
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    backgroundColor: '#ff4757',
    padding: 16,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  },
  errorText: {
    color: '#fff',
    fontSize: 16,
    marginRight: 20,
  },
  errorClose: {
    color: '#fff',
    fontSize: 20,
    padding: 4,
  },
  
  // 스크롤 영역
  scrollView: {
    flex: 1,
  },
  
  // 콘텐츠 영역
  content: {
    maxWidth: 1200,
    width: '100%',
    marginHorizontal: 'auto' as any,
    padding: 24,
  },
  
  // 로딩
  loadingContainer: {
    minHeight: 600,
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingText: {
    fontSize: 18,
    marginTop: 20,
    color: '#666',
  },
  
  // 헤더 섹션
  headerSection: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 24,
    marginBottom: 24,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 3,
  },
  headerContent: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  pageTitle: {
    fontSize: 28,
    fontWeight: 'bold',
    color: '#1a1a1a',
    marginBottom: 4,
  },
  pageSubtitle: {
    fontSize: 16,
    color: '#666',
  },
  refreshButton: {
    backgroundColor: '#1890ff',
    paddingHorizontal: 24,
    paddingVertical: 10,
    borderRadius: 6,
  },
  refreshText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '500',
  },
  
  // 상태 개요 섹션
  overviewSection: {
    marginBottom: 24,
  },
  overviewGrid: {
    flexDirection: 'row',
    gap: 24,
  },
  overviewCard: {
    flex: 1,
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 24,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 3,
  },
  overviewCardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
    paddingBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  overviewCardTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#333',
  },
  statusIndicator: {
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 12,
  },
  statusIndicatorText: {
    color: '#fff',
    fontSize: 14,
    fontWeight: '500',
  },
  overviewCardBody: {
    gap: 16,
  },
  overviewInfo: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  overviewLabel: {
    fontSize: 14,
    color: '#666',
  },
  overviewValue: {
    fontSize: 16,
    fontWeight: '500',
    color: '#1a1a1a',
  },
  nextRunTime: {
    fontSize: 20,
    fontWeight: '600',
    color: '#1890ff',
    marginBottom: 20,
    textAlign: 'center',
  },
  syncButton: {
    backgroundColor: '#1890ff',
    paddingVertical: 12,
    borderRadius: 6,
    alignItems: 'center',
  },
  syncButtonDisabled: {
    backgroundColor: '#d9d9d9',
  },
  syncButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
  },
  
  // 실행 이력 섹션
  historySection: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 24,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 3,
  },
  sectionHeader: {
    marginBottom: 24,
    paddingBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  sectionTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: '#333',
  },
  
  // 테이블
  historyTable: {
    borderWidth: 1,
    borderColor: '#e8e8e8',
    borderRadius: 4,
    overflow: 'hidden',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#fafafa',
    borderBottomWidth: 2,
    borderBottomColor: '#e8e8e8',
  },
  tableHeaderCell: {
    paddingVertical: 14,
    paddingHorizontal: 16,
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
    backgroundColor: '#fff',
  },
  tableCell: {
    paddingVertical: 14,
    paddingHorizontal: 16,
    fontSize: 14,
    color: '#333',
    alignItems: 'center',
    justifyContent: 'center',
  },
  colDate: {
    flex: 2,
  },
  colStatus: {
    flex: 1,
    alignItems: 'center',
  },
  colRecords: {
    flex: 1,
    textAlign: 'center',
  },
  colDuration: {
    flex: 1,
    textAlign: 'center',
  },
  statusBadge: {
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 4,
  },
  statusBadgeText: {
    color: '#fff',
    fontSize: 13,
    fontWeight: '500',
  },
  
  // 빈 상태
  emptyState: {
    padding: 60,
    alignItems: 'center',
  },
  emptyStateText: {
    fontSize: 16,
    color: '#999',
  },
  
  // 페이지네이션
  pagination: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 24,
    gap: 20,
  },
  pageButton: {
    paddingVertical: 8,
    paddingHorizontal: 20,
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#d9d9d9',
    borderRadius: 4,
  },
  pageButtonDisabled: {
    backgroundColor: '#f5f5f5',
    borderColor: '#d9d9d9',
  },
  pageButtonText: {
    fontSize: 14,
    color: '#333',
  },
  pageInfo: {
    fontSize: 14,
    color: '#666',
  },
});